export interface UserConfig {
  invitationUrl: string;
}

export function getUserConfig(): UserConfig {
  return {
    invitationUrl: `${window.location.origin}/#/user-invitation/{token}`,
  };
}
